// extracted by mini-css-extract-plugin
module.exports = {"learningArticle":"LearningArticle_learningArticle__12IAm","h1":"LearningArticle_h1__13SaD","divider":"LearningArticle_divider__3jnJ6"};